export default {
  oceania: "magenta",
  americas: "blue",
  asia: "orange",
  europe: "mint",
  africa: "yellow",
  mideast: "brown",
  global: "purple",
  [null]: "gray",
}